var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-sm-drop statusbtn",class:[_vm.colorClass, { 'jd-list': _vm.isJDList }]},[_c('button',{staticClass:"btn btn-secondary"},[_vm._v(_vm._s(_vm.status))])])}
var staticRenderFns = []

export { render, staticRenderFns }